var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:no-null-keyword
import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { componentWithProps } from "../generic/componentWithProps";
import { menuTabs } from "../menus/menuTabs";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionDoghouseSetDogToIdle } from "./actionDoghouse";
import { DoghouseFreeTreatsGivenFooter } from "./DoghouseFreeTreatsGivenFooter";
var MenuDoghouseDOM = /** @class */ (function (_super) {
    __extends(MenuDoghouseDOM, _super);
    function MenuDoghouseDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.props.initDogState();
        return _this;
    }
    MenuDoghouseDOM.prototype.render = function () {
        var _a = this.props, tabId = _a.tabId, onClose = _a.onClose, onInfoClick = _a.onInfoClick;
        var categoryConfig = tabId
            ? menuTabs[IdMenuBalancing.DogHouse].categories[tabId]
            : undefined;
        var resourcesToDisplay = categoryConfig ? categoryConfig.footerResources || [] : [];
        var footerComponent = componentWithProps({
            ComponentType: DoghouseFreeTreatsGivenFooter,
            resources: resourcesToDisplay,
        });
        return (React.createElement(MenuWrapper, { onClose: onClose, className: "doghouse-dialog", footerRenderer: footerComponent, type: IdMenuBalancing.DogHouse, modalId: IdModal.Doghouse, onInfoClick: onInfoClick }));
    };
    return MenuDoghouseDOM;
}(React.PureComponent));
var mapState = function (state) { return ({
    tabId: selectModalTabId(state, IdModal.Doghouse),
}); };
var mapDispatch = function (dispatch) { return ({
    initDogState: function () { return dispatch(actionDoghouseSetDogToIdle()); },
    onClose: function () { return dispatch(actionModalClose(IdModal.Doghouse)); },
    onInfoClick: function () { return dispatch(actionModalOpen(IdModal.DoghouseInfo)); },
}); };
export var MenuDoghouse = connect(mapState, mapDispatch)(MenuDoghouseDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/MenuDoghouse.tsx
// module id = 2820
// module chunks = 3